import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import groupBy from 'lodash/groupBy';

import IllustrationCard from '../IllustrationCard/IllustrationCard';
import { FILTERKEYS } from '../constants';

const IllustrationsList = ({ content }) => {
  const dataGroup = groupBy(content, 'type');
  const dataKeys = Object.keys(dataGroup);

  return (
    <Fragment>
      {dataKeys.map((group, i) => 
        <section key={`illustration-group-${i}`} className="with-padding">
          <h2 className="h2 page-subtitle">{FILTERKEYS[group]}</h2>
          <ul>
            {
              dataGroup[group].map((illustration, i) => {
                return (
                  <IllustrationCard
                    key={`illustration-${i}`}  
                    { ...illustration }
                  />
                );
              })
            }
          </ul>
        </section>
      )}
    </Fragment>
  );
};

IllustrationsList.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired
};

IllustrationsList.defaultProps = {
  content: []
};

IllustrationsList.displayName = 'IllustrationsList';

export default IllustrationsList;



// WEBPACK FOOTER //
// ./src/containers/foundations/Illustrations/IllustrationsList/IllustrationsList.js